import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketer',
  templateUrl: './marketer.component.html',
  styleUrls: ['./marketer.component.css']
})
export class MarketerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
